import { NotFoundBody } from '@framework/ui';
import * as React from 'react';
import {
  AlertPageLayout,
  IAlertPageLayoutProps,
} from '../components/AlertPageLayout';

export interface INotFoundPageProps
  extends Omit<IAlertPageLayoutProps, 'children'> {
  message?: React.ReactNode;
  description?: React.ReactNode;
}

export function NotFoundPage(props: INotFoundPageProps) {
  const { message, description, ...rest } = props;
  return (
    <AlertPageLayout {...rest}>
      <NotFoundBody message={message} description={description} />
    </AlertPageLayout>
  );
}
